import React from 'react';
import tecno from '../../Tecno-list/tecno';
import { Link } from 'react-router-dom';

function Business() {






    return (
        <React.Fragment>
            <section className='Proyect'>

                <h2 className="">Business Intelligence</h2>
                <div className='folder-porfolio'>


                    <iframe src="https://www.youtube.com/embed/R9BPb-BGPNQ" title="YouTube video player" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>

                    <div className="list" >



                        {tecno.filter(tec => tec.T === 'Qlik Sense' || tec.T === 'Pentaho' || tec.T === 'Oracle').map(tec => (


                            <div key={tec.T}>

                                <a href={tec.L} target="_blank" rel="noreferrer">

                                    <button className="etiqueta">  <p> <span>&#183;</span> {tec.T}</p></button>
                                </a>
                            </div>

                        ))}
                    </div>

                    <p className='white'>
                        This BI project combines data from the OE and Northwind databases,
                        creating a star model applying ETL processes with Pentaho and BI graphs with
                        Qlik Sense Desktop.
                    </p>

                    <a href="https://github.com/BrandonGrimaldoM/BIQlikSense" target="_blank" rel="noreferrer">
                        <button className="Git"> <p>Repository </p> <div className="gitIcon"></div> </button>
                    </a>
                </div>


                <div className='after'>
                    <Link to="/data-base" className="Link">  <div className='iconAfter'>  <p className='flecha'>←</p></div>  </Link>
                </div>

            </section>
        </React.Fragment>
    );
}
export default Business;